export default "__VITE_ASSET__Blfyp9TF__"